export default "__VITE_ASSET__B2QN0lGK__"